import script from "./addSafeguardProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./addSafeguardProduct.vue?vue&type=script&setup=true&lang=js"

import "./addSafeguardProduct.vue?vue&type=style&index=0&id=4f47dbdc&lang=scss&scoped=true"
import "./addSafeguardProduct.vue?vue&type=style&index=1&id=4f47dbdc&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f47dbdc"]])

export default __exports__